export const copiesKeyMap = {
  'error.order_not_found': 'default',
  'error.order_cancelled': 'cancelled',
  'error.disabled_by_rule': 'disabledByRule',
  'error.from_previous_exchange': 'reveniExchange',
  'error.order_no_amount': 'noAmount',
  'error.order_with_giftcard': 'disabledGiftcard',
  'error.has_external_returns': 'externalReturns',
  'error.order_disabled_channel': 'disabledChannel',
  'error.order_region_not_allowed': 'regionNotAllowed',
  'error.order_pending_payment': 'pendingPayment',
  'error.order_with_chargeback': 'chargeback',
  'error.exchange_not_allowed': 'exchangeNotAllowed',
}
